// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://qfozcnxbtjjmidhjdepc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFmb3pjbnhidGpqbWlkaGpkZXBjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAzMzIxNTcsImV4cCI6MjA4NTkwODE1N30.M_VHiUyMhOnhtUbtw9FoUk-YKLIOXYC5eNVrD-A4vX8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// NOTE: Using 'any' type assertion because the auto-generated types.ts is out of sync
// with the actual database schema (missing many tables and columns).
// This is a temporary measure until types.ts is regenerated from the current schema.
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
}) as any;